import { UseAxiosResult } from "axios-hooks";
import { PasswordOptions } from "shared";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

import { UseSelectUserManagementApi } from "./setup";

export interface ResetPasswordCreate {
  email: string;
  password: string;
  confirmPassword: string;
  token: string;
}

export const useResetPassword = (): UseAxiosResult => {
  return UseSelectUserManagementApi(
    {
      url: formatUrl(api.password.reset),
      method: "POST",
    },
    {
      manual: true,
    }
  );
};

export const useSendResetPasswordEmail = (
  email: string,
  redirectUrl?: string | undefined
): UseAxiosResult => {
  return UseSelectUserManagementApi(
    {
      url: formatUrl(api.password.resetEmail),
      method: "POST",
      params: {
        email,
        ...(redirectUrl ? { redirectUrl } : {}),
      },
    },
    {
      manual: true,
    }
  );
};

export const useGetResetPasswordOptions = (
  email: string
): UseAxiosResult<PasswordOptions> => {
  return UseSelectUserManagementApi<PasswordOptions>(
    {
      url: formatUrl(api.password.passwordOptions),
      method: "GET",
      params: { email },
    },
    {
      manual: true,
    }
  );
};
